// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: var(--body-color);
  font-family: "Inter", serif;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

a {
  color: inherit;
  text-decoration: none;
}
ul {
  padding: 0;
}
.rec-slider-container {
  margin: 0px !important;
}
.white-space {
  white-space: nowrap;
}

li {
  list-style-type: none;
}
h1,
h2,
h3,
h4,
h5,
h6,
p,
button,
a,
svg {
  margin: 0px;
}
/* scroll bar */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: rgb(172, 166, 166);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: rgb(156, 151, 151);
}

/* scroll bar */

.cursor-pointer {
  cursor: pointer;
}
.overflowHidden {
  overflow: hidden;
}
.box {
  background-color: var(--white-color);
  border-radius: 20px;
  padding: 24px;
  height: auto;
}
.capitalize {
  text-transform: capitalize;
}

.maxLine1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.maxLine2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.maxLine3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.maxLine6 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  line-clamp: 6;
  -webkit-box-orient: vertical;
}

input {
  outline: none;
  border: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.cardBoxShadow {
  box-shadow: 0px 5px 25px #0000000d;
}

.text-green {
  color: var(--primary-color);
}

.white-color {
  color: var(--white-color);
}

.text-color-v2 {
  color: var(--text-color-v2);
}

.para-text {
  color: var(--para-text);
}

.red-color {
  color: var(--red-color);
}

.black-color {
  color: var(--black-color);
}
/* .modal-content {
  min-height: 500px !important;
} */
`, "",{"version":3,"sources":["webpack://./src/assets/css/globals.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;AACA;;;;;;;;;;EAUE,WAAW;AACb;AACA,eAAe;AACf;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;;AAEA,eAAe;;AAEf;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;GAEG","sourcesContent":["body {\n  background-color: var(--body-color);\n  font-family: \"Inter\", serif;\n}\n\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\nul {\n  padding: 0;\n}\n.rec-slider-container {\n  margin: 0px !important;\n}\n.white-space {\n  white-space: nowrap;\n}\n\nli {\n  list-style-type: none;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nbutton,\na,\nsvg {\n  margin: 0px;\n}\n/* scroll bar */\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n::-webkit-scrollbar-track {\n  border-radius: 10px;\n}\n::-webkit-scrollbar-thumb {\n  background: rgb(172, 166, 166);\n  border-radius: 10px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background-color: rgb(156, 151, 151);\n}\n\n/* scroll bar */\n\n.cursor-pointer {\n  cursor: pointer;\n}\n.overflowHidden {\n  overflow: hidden;\n}\n.box {\n  background-color: var(--white-color);\n  border-radius: 20px;\n  padding: 24px;\n  height: auto;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n\n.maxLine1 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  line-clamp: 1;\n  -webkit-box-orient: vertical;\n}\n\n.maxLine2 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.maxLine3 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n.maxLine6 {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 6;\n  line-clamp: 6;\n  -webkit-box-orient: vertical;\n}\n\ninput {\n  outline: none;\n  border: none;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.cardBoxShadow {\n  box-shadow: 0px 5px 25px #0000000d;\n}\n\n.text-green {\n  color: var(--primary-color);\n}\n\n.white-color {\n  color: var(--white-color);\n}\n\n.text-color-v2 {\n  color: var(--text-color-v2);\n}\n\n.para-text {\n  color: var(--para-text);\n}\n\n.red-color {\n  color: var(--red-color);\n}\n\n.black-color {\n  color: var(--black-color);\n}\n/* .modal-content {\n  min-height: 500px !important;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
